import { scrub } from "./scrub";
import { getTelemetryRoute, isTelemetryEnabled, trackEvent } from "./telemetry";

const INTERACTIVE = [
  "[data-telemetry-label]", "button", "a[href]", "summary",
  'input:is([type="checkbox"], [type="radio"], [type="submit"], [type="button"])',
  ...["button", "link", "tab", "menuitem", "option", "switch", "checkbox", "radio"].map(role => `[role="${role}"]`),
].join(",");
export const MASK_ATTRIBUTE = "data-telemetry-mask";
const MAX_LABEL_LENGTH = 80;
let installed = false;

/** Records which control was clicked, labelled without reading input values or masked user data. Call after `initTelemetry`. */
export function installClickTelemetry() {
  if (installed || !isTelemetryEnabled()) return;
  installed = true;
  document.addEventListener("click", (event) => {
    try {
      const target = event.target instanceof Element ? event.target.closest(INTERACTIVE) : null;
      if (!target) return;
      trackEvent("ui.clicked", { route: getTelemetryRoute(), element: describe(target), label: labelOf(target) });
    } catch { /* ignore telemetry failures */ }
  }, { capture: true });
}

function describe(element: Element) {
  const role = element.getAttribute("role");
  const tag = element.tagName.toLowerCase();
  if (role) return `${tag}[role=${role}]`;
  return tag === "input" ? `input[type=${element.getAttribute("type")}]` : tag;
}

function labelOf(element: Element) {
  const fixed = element.getAttribute("data-telemetry-label");
  if (fixed) return fixed.slice(0, MAX_LABEL_LENGTH);
  if (element.closest(`[${MASK_ATTRIBUTE}]`)) return "[masked]";
  const text = visibleText(element) || element.getAttribute("aria-label") || element.getAttribute("title") || "";
  const label = scrub(text.replace(/\s+/g, " ").trim());
  return label ? label.slice(0, MAX_LABEL_LENGTH) : "[unlabelled]";
}

function visibleText(node: Node): string {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent ?? "";
  if (!(node instanceof Element)) return "";
  if (node.hasAttribute(MASK_ATTRIBUTE)) return " [masked] ";
  if (node.getAttribute("aria-hidden") === "true" || /^(input|textarea|select|svg)$/i.test(node.tagName)) return " ";
  return Array.from(node.childNodes, visibleText).join(" ");
}
